import React from "react";
import Card from "react-bootstrap/Card";
import {Box} from "@mui/material";
import Util from "../../Util/Util";
import {BarChart} from "@mui/x-charts/BarChart";

export default class ColumnChart extends React.Component {

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }

    render() {
        let {title, chartData} = this.props;
        let keys = Util.translateAges(Object.keys(chartData));
        let values = Object.values(chartData);
        let total = values.reduce((a, b) => a + b, 0);
        return (
            <Card>
                <Card.Header>{title}</Card.Header>
                <Card.Body>
                    <Box sx={{width: '100%'}}>
                        <BarChart data={chartData} keys={keys}
                                  xAxis={[{
                                      scaleType: 'band',
                                      data: keys,
                                  }]}
                                  series={[{
                                      data: values, valueFormatter: (val) => {
                                          let percentage = val * 100 / total;
                                          return val?.toString() + " (" + percentage.toFixed(1) + "%)";
                                      }
                                  }]}
                                  barLabel={(item, context) => {
                                      let percentage = item.value * 100 / total;
                                      let val = item.value?.toString() + " (" + percentage.toFixed(1) + "%)";
                                      return context.bar.height < 20 ? null : val;
                                  }}
                                  height={300}
                        />
                    </Box>
                </Card.Body>
            </Card>
        )
    }

    valueFormatter = (value, total) => {
        let percentage = value * 100 / total;
        return value?.toString() + " ( " + percentage.toFixed(1) + "% )";
    }
}